var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuApiResources(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Menu - API resources",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 12009"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - Menu - API scopes"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.656 3.453a.8.8 0 1 0-.8-.8.795.795 0 0 0 .8.8zm2.656-.8A2.651 2.651 0 0 1 3.719 5.09v1.285a1.061 1.061 0 0 0 1.062 1.063h5.313a1.061 1.061 0 0 0 1.063-1.062V5.09a2.656 2.656 0 1 1 2.125 0v1.285a3.159 3.159 0 0 1-.182 1.069 5.854 5.854 0 0 0-1.677 1.829 3.166 3.166 0 0 1-1.325.289H8.5v2.348a2.656 2.656 0 1 1-2.125 0V9.563H4.781a3.188 3.188 0 0 1-3.187-3.188V5.09a2.656 2.656 0 1 1 3.719-2.434zm6.906.8a.8.8 0 1 0-.8-.8.795.795 0 0 0 .801.8zM8.234 14.344a.8.8 0 1 0-.8.8.795.795 0 0 0 .8-.8zm3.453-2.125A4.781 4.781 0 1 1 16.469 17a4.782 4.782 0 0 1-4.781-4.781zm7.016-.687a.531.531 0 0 0-.75-.75L15.938 12.8l-.953-.953a.531.531 0 0 0-.75.75l1.328 1.328a.533.533 0 0 0 .75 0z",
    transform: "translate(1 4)",
    style: {
      fill: "#778187"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuApiResources);
export default __webpack_public_path__ + "static/media/IconMenuApiResources.a47a112357e2ad32296961b355db47f8.svg";
export { ForwardRef as ReactComponent };